export default "__VITE_ASSET__CtxKCh_8__"